import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LanguageManagementService } from 'src/service/language-management.service';
import { KeyValueSets, LanguageKeyType, LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-language-history',
  templateUrl: './language-history.component.html',
  styleUrls: ['./language-history.component.scss']
})
export class LanguageHistoryComponent implements OnInit {
  maxBodyHeight = 0; parentId: string = ''; languageKeyType: LanguageKeyType = LanguageKeyType.None;
  items: KeyValueSets[];

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.languageManagementService.getLanguageHistories(LanguageKeyType.ProductName, this.parentId).subscribe(result => {
      this.items = result;
    });
  }

}
